module.exports = __webpack_public_path__ + "static/media/42.394d5466.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sports/svg/42.svg
// module id = 151
// module chunks = 0